import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-3 mb-1 room-h2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "row mx-auto" }
const _hoisted_5 = { class: "col-12 mt-2 px-0" }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = { class: "row my-3" }
const _hoisted_9 = { class: "col-12 col-md-4 offset-md-4" }
const _hoisted_10 = { class: "col-12 d-flex justify-content-end mt-3 px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_shopping_cart = _resolveComponent("link-shopping-cart")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_link_arrow = _resolveComponent("link-arrow")!
  const _component_calendar_month_selector = _resolveComponent("calendar-month-selector")!
  const _component_calendar_monthly = _resolveComponent("calendar-monthly")!
  const _component_link_default = _resolveComponent("link-default")!
  const _component_button_panic = _resolveComponent("button-panic")!
  const _component_loading_container = _resolveComponent("loading-container")!
  const _component_link_faq = _resolveComponent("link-faq")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('views.room.title')), 1),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errorLinkTo: "/",
      i18nErrorMessage: _ctx.getI18nErrorString()
    }, {
      default: _withCtx(() => [
        _createVNode(_component_link_shopping_cart),
        (!_ctx.showMaxReservations && !_ctx.showDuplicateReservation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.room.name), 1),
              _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.room.description), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.showMaxReservations)
          ? (_openBlock(), _createBlock(_component_error_message, {
              key: 1,
              i18nMessage: _ctx.$t('common.maxReservations', _ctx.maxReservations),
              class: "mt-2"
            }, null, 8, ["i18nMessage"]))
          : _createCommentVNode("", true),
        (_ctx.showDuplicateReservation)
          ? (_openBlock(), _createBlock(_component_error_message, {
              key: 2,
              i18nMessage: _ctx.$t('common.duplicateReservation'),
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_button_cancel, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDuplicateReservation = false)),
                      i18nMessage: _ctx.$t('common.backToOverview'),
                      class: "btn-to-danger-link text-black mt-3"
                    }, null, 8, ["i18nMessage"])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["i18nMessage"]))
          : _createCommentVNode("", true),
        (!_ctx.showMaxReservations && !_ctx.showDuplicateReservation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_link_arrow, {
                i18nMessage: "views.room.chooseAnotherRoom",
                to: "/",
                class: "mb-1"
              }),
              _createVNode(_component_calendar_month_selector, {
                calendarForDay: _ctx.calendarForDay,
                onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMonth($event))),
                class: "mt-3"
              }, null, 8, ["calendarForDay"]),
              _createVNode(_component_calendar_monthly, {
                room: _ctx.room,
                days: _ctx.days,
                onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onTimeSlotClicked($event))),
                class: "calendar-mobile"
              }, null, 8, ["room", "days"]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tc('views.room.infoTextCount', { count: _ctx.remainingReservationsCount(), max: _ctx.maxReservations} )) + " " + _toDisplayString(_ctx.hasRemainingTime() && _ctx.$tc('views.room.infoTextUnblock', _ctx.remainingMinutes()) || ''), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_link_default, {
              i18nMessage: "common.goToYourReservationsSimple",
              to: "/your-reservations",
              class: "btn btn-outline-brand1 w-100 link-to-outline-btn"
            })
          ])
        ]),
        _createVNode(_component_button_panic, { class: "btn-to-danger-link d-flex justify-content-end pr-3 mt-5" })
      ]),
      _: 1
    }, 8, ["state", "i18nErrorMessage"]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_link_faq)
    ])
  ]))
}